type FeatureFlag = "hito_1" | "hito_2" | "hito_3";

const allFlags: FeatureFlag[] = ["hito_1", "hito_2", "hito_3"];

export function useFeatureFlag() {
  const featureFlags = Object.fromEntries(
    allFlags.map((flag) => [flag, (import.meta as any).env[`VITE_${flag.toUpperCase()}`] === "true"])
  ) as Record<FeatureFlag, boolean>;

  const isFeatureEnabled = (feature: FeatureFlag): boolean => featureFlags[feature];

  return { isFeatureEnabled };
}
